import { device } from '../device/device.js';

/**
 * When ui-router $stateChangeStart fires, update css class of <html> element.
 * Sets two CSS classes: "old-state-app-OldStateName" and "state-app-NewStateName"
 * @param {Object} $rootScope
 */
export function setDocumentClass($rootScope) {
	'ngInject';
	$rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
		let doc = document.documentElement;
		// remove old classes
		doc.className = doc.className.replace(/(^|\s+)(old-)?state-\S+/g, '');
		// set new classes
		const longFromState = sanitize(fromState.name);
		const longToState = sanitize(toState.name);
		const shortFromState = sanitize(shortName(fromState.name));
		const shortToState = sanitize(shortName(toState.name));
		const isLoggedIn = /-loggedin-/.test(longToState);
		const iframeClass = window.top === window ? 'is-not-iframe' : 'is-iframe';
		const mobileClass = device.isMobile() ? 'device-is-mobile' : 'device-is-desktop';
		const phoneClass = device.isPhone() ? 'device-is-phone' : '';
		const tabletClass = device.isTablet() ? 'device-is-tablet' : '';
		angular
			.element(doc)
			.addClass('old-state-' + longFromState)
			.addClass('old-state-' + shortFromState)
			.addClass('state-' + longToState)
			.addClass('state-' + shortToState)
			.addClass('state-' + (isLoggedIn ? 'loggedin' : 'loggedout'))
			.addClass(iframeClass)
			.addClass(mobileClass)
			.addClass(phoneClass)
			.addClass(tabletClass);
	});
}

const sanitize = name => {
	return (name || 'undefined').replace(/\W+/g, '-');
};

const shortName = name => {
	const parts = (name || 'undefined').split('.');
	return parts[parts.length - 1];
};
